/**
 * Resolve the label shown for a job's assignee.
 *
 * A job scheduled to a team stores the first team member in `assigned_to`, so
 * the resolved user name is a real person rather than the team (WRK-5662). When
 * a team name is present it takes precedence; otherwise we fall back to the
 * individual user's name. Blank/whitespace values are treated as absent.
 */
export function resolveAssigneeLabel(
  teamName: string | null | undefined,
  userName: string | null | undefined,
): string | undefined {
  const team = teamName?.trim();
  if (team) return team;

  const user = userName?.trim();
  if (user) return user;

  return undefined;
}
